import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { notBlankValidation } from '../../../utils/validations';
import Button from '../../shared/buttons/Button';
import Input from '../../shared/input/Input';

const ChangePasswordForm = ({ loading, handleChangeMyInfo, userData }) => {
  const methods = useForm({ defaultValues: userData });
  return (
    <FormProvider {...methods}>
      <form
        id="my-form"
        noValidate
        className="modal-form"
        onSubmit={methods.handleSubmit((data) => {
          handleChangeMyInfo(data);
        })}
      >
        <Input
          label="Ім'я"
          type="input"
          name="firstName"
          loading={loading}
          placeholder="Введіть ім'я"
          validation={notBlankValidation}
        />
        <Input
          label="Прізвище"
          type="input"
          name="lastName"
          loading={loading}
          placeholder="Введіть прізвище"
          validation={notBlankValidation}
        />
        <div className="w-full flex justify-end">
          <Button
            className={'mt-2'}
            type={'submit'}
            disabled={loading}
            variant={'primary'}
            formId={'my-form'}
            children={'Зберегти'}
          />
        </div>
      </form>
    </FormProvider>
  );
};

export default ChangePasswordForm;
